import { Injectable } from '@angular/core';
import { first, takeUntil } from 'rxjs/operators';

import { AnalyticsService } from 'analytics-api';
import { analyticsDimensions, analyticsEvents } from 'extensions/analytics';
import { EcommerceContext } from 'idt-ecommerce-api/context/context.models';
import { ContextService } from 'idt-ecommerce-api/context/context.service';
import { RenderConfigurationService } from 'render/services/render-configuration.service';
import { UnsubscribeComponent } from 'shared/directives/unsubscribe.component';

import { AnalyticsComponentEvent } from './models/cms-analytics-event.model';


@Injectable()
export class CmsAnalyticsService extends UnsubscribeComponent {

  private readonly events: string[] = [];

  constructor(
    private readonly contextService: ContextService,
    private readonly renderConfigurationService: RenderConfigurationService,
    private readonly analyticService: AnalyticsService<EcommerceContext, AnalyticsComponentEvent>
  ) {
    super();
    const analytics = this.renderConfigurationService.config.analytics;
    this.events = Object.keys(analyticsEvents);
    this.analyticService.updateConfig({
      brandSettings: analyticsEvents,
      brandDimensions: analyticsDimensions,
      allowMultipleGtmScripts: !!analytics?.allowMultipleGtmScripts
    });
    this.contextService.getStore$().pipe(
      takeUntil(this.clearSubscriptions$)
    ).subscribe((storeInfo) => {
      const cmsConfig = storeInfo?.details?.cmsConfigurations;
      if (cmsConfig?.enableAnalyticsRender && cmsConfig?.gtmId) {
        this.analyticService.updateConfig({
          cmsConfig: {
            enableAnalyticsRender: cmsConfig.enableAnalyticsRender,
            gtmId: cmsConfig.gtmId
          }
        });
      }
    });
  }

  public track(event: string, settings: AnalyticsComponentEvent): void {
    this.contextService.getContext$().pipe(
      first()
    ).subscribe((context) => {
      this.analyticService.updateConfig({
        context
      });
      this.analyticService.track(event, settings);
    });
  }

  public getEvents() {
    return this.events;
  }

}
